export default `
query DivisionRelations(
  $serviceProviderId: ID!,
  $to: Float,
  $from: Float,
  $after: ID
) {
  queryDivisionRelationsByServiceProviderIdUpdatedAtIndex(
    serviceProviderId: $serviceProviderId,
    to: $to,
    from: $from,
    after: $after
  ) {
    items {
      divisionId
      relationalId
      variant
      serviceProviderId
      updatedAt
      isDeleted
    }
    nextToken
  }
}
`;